<template>
    <div v-if="productModal.isVisible">
        <div class="overlay" @click="closeModal"></div>
        <div class="modal-container">
            <i class="fa fa-magnifying-glass"></i>
            <div class="modal-body">
                <h1 class="name">{{ productModal.product.NMPRODUTO }}</h1>
                <img :src="productModal.product.DSENDEIMG" />
                <h1 class="description" v-if="productModal.product.DSPRODVENDA">{{ productModal.product.DSPRODVENDA }}</h1>
                <div class="value">
                    Valor
                    <h1>{{ productModal.product.VRPRECITEM.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h1>
                </div>
            </div>
            <div class="modal-footer">
                <button @click="closeProductModal">Fechar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'ProductModal',
    components: {
    },
    data () {
        return {
            date: new Date()
        }
    },
    computed: {
        ...mapGetters(['productModal'])
    },
    methods: {
        ...mapActions(['closeProductModal']),
        closeModal () {
            this.closeProductModal()
        }
    }
}
</script>

<style lang="less" scoped>
.modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto 30px;
    border-radius: 10px;
    z-index: 3;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    background-color: white;
    height: max-content;
    display: flex;
    flex-direction: column;
    align-items: center;

    i {
        margin-top: 20px;
    }
    .modal-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 10px;

        h1 {
            text-align: center;
            margin-left: 10px;
            margin-right: 10px;
        }

        .name {
            font-weight: 600;
        }

        .description {
            margin-bottom: 40px;
        }

        img {
            max-height: 200px;
            object-fit: contain;
            max-width: 90%;
            margin-top: 20px;
            margin-bottom: 20px;
        }

        .value {
            display: flex;
            flex-direction: row;
            margin-bottom: 20px;
            font-weight: 600;

            h1 {
                font-weight: 600;
                color: var(--primaryColor);
                margin-left: 10px;
            }
        }
    }

    .modal-footer {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        button {
            color:white;
            background: var(--primaryColor);
            padding: 5px 10px;
            border: none;
            border-radius: 5px;
            min-width: 90px;
        }
    }
}
.overlay {
    position: fixed;
    top: 0; left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.21);
    z-index: 2;
}

@media (max-height: 490px) {
    .modal-container {
        .modal-body {
            img {
                display: none;
            }
            .description {
                margin-top: 20px;
            }
        }
    }
}

</style>
